export const frequentServiceRouteShortNames = [];

export const multiPlatformStopIds = [];

export const cableCarStopIds = [];

export const isFrequentRoute = (routeLabel) =>
  frequentServiceRouteShortNames.includes(routeLabel);
